import React from "react";

import { Button } from "@material-ui/core";

import MonthSelector from "./MonthSelector";
import { getDateString } from "../../helpers/dateHelpers";

import moment from "moment";
import { openConfirm } from "../../components/confirmBox/ConfirmBox";

const Render = (props) => {
  const { actions, portfolio, portfolioEntry } = props;

  const [showMonthSelector, showMonthSelector_set] = React.useState();

  const monthStartEntered = portfolio.startMonth && portfolio.startYear;

  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", marginTop: 25 }}>
        <div style={{ width: 350 }}>
          <div style={{ fontWeight: "bold" }}>Analysis Period Start Date</div>
          <div style={{ marginTop: 15 }}>
            <div style={{}}>
              <span>
                {portfolio.startMonth && portfolio.startYear
                  ? `${getDateString(
                      portfolio.startMonth,
                      portfolio.startYear
                    )}`
                  : "Not Entered"}
              </span>
              <Button
                onClick={() => {
                  showMonthSelector_set("start");
                }}
                color="primary"
                variant="outlined"
                style={{ textTransform: "initial", marginLeft: 20 }}
              >
                {portfolio.startMonth && portfolio.startYear
                  ? "Modify Start Date"
                  : "Set Start Date"}
              </Button>
            </div>
          </div>
        </div>
        <div
          style={{
            width: 350,
            marginLeft: 30,
            color: monthStartEntered ? "inherit" : "grey",
          }}
        >
          <div style={{ fontWeight: "bold" }}>Analysis Period End Date</div>
          <div style={{ marginTop: 15 }}>
            <div style={{}}>
              <span>
                {portfolio.endMonth && portfolio.endYear
                  ? `${getDateString(portfolio.endMonth, portfolio.endYear)}`
                  : "Not Entered"}
              </span>
              <Button
                disabled={!monthStartEntered}
                onClick={() => {
                  showMonthSelector_set("end");
                }}
                color="primary"
                variant="outlined"
                style={{ textTransform: "initial", marginLeft: 20 }}
              >
                {portfolio.endMonth && portfolio.endYear
                  ? "Modify End Date"
                  : "Set End Date"}
              </Button>
            </div>
          </div>
        </div>
      </div>

      {showMonthSelector === "start" && (
        <div>
          <MonthSelector
            {...props}
            showEndDate={false}
            startDate={portfolioEntry.dateRange.startingDate}
            endDate={portfolioEntry.dateRange.endDate}
            month={portfolio.startMonth}
            year={portfolio.startYear}
            okClick={(month, year, endMonth, endYear) => {
              var values = [
                { key: "startMonth", value: month },
                { key: "startYear", value: year },
              ];

              if (
                portfolio.endYear &&
                (portfolio.endYear < year ||
                  (portfolio.endYear === year && portfolio.endMonth <= month))
              ) {
                values = [
                  ...values,
                  { key: "endMonth", value: null },
                  { key: "endYear", value: null },
                ];
              }

              if (
                year > portfolio.startYear ||
                (portfolio.startYear === year && month > portfolio.startMonth)
              ) {
                //may need to show a notification to the user.
                //commented out for now
                // openConfirm({
                //   title: "PPF recalculated",
                //   isAlert: true,
                //   description: "The starting month has changed and the PPF has been recalculated to the new initial closing value."
                // })
              } else {
              }
              actions.setPortfolioValues(
                props,
                portfolio.portfolioNumber,
                values
              );

              showMonthSelector_set(false);
            }}
            cancelClick={() => {
              showMonthSelector_set(false);
            }}
          />
        </div>
      )}
      {showMonthSelector === "end" && (
        <div>
          <MonthSelector
            {...props}
            showEndDate={false}
            month={portfolio.endMonth}
            year={portfolio.endYear}
            startDate={new Date(portfolio.startYear, portfolio.startMonth)}
            endDate={portfolioEntry.dateRange.endDate}
            okClick={(month, year) => {
              var values = [
                { key: "endMonth", value: month },
                { key: "endYear", value: year },
              ];
              actions.setPortfolioValues(
                props,
                portfolio.portfolioNumber,
                values
              );

              showMonthSelector_set(false);
            }}
            cancelClick={() => {
              showMonthSelector_set(false);
            }}
          />
        </div>
      )}
    </div>
  );
};

const getErrors = (props) => {
  const ret = [];

  const { portfolio } = props;

  if (!portfolio.startMonth || !portfolio.startYear) {
    ret.push("Analysis period start date is required.");
  } else if (!portfolio.endMonth || !portfolio.endYear) {
    ret.push("Analysis period end date is required.");
  }

  if (portfolio.portfolioValues.length < 10) {
    ret.push("A minimum of 10 months are required for analysis.");
  }

  return ret;
};

function isComplete(props) {
  const errors = getErrors(props);

  return errors.length === 0;
}

const Description = (props) => {
  const { portfolioEntry } = props;

  return (
    <div>
      <p>
        Select your analysis period, for example, Feb 28, 2009 to May 31, 2010.
      </p>
      <ul>
        {portfolioEntry && portfolioEntry.dateRange && (
          <li>
            The earliest permitted starting date is{" "}
            {moment(portfolioEntry.dateRange.startingDate)
              .endOf("month")
              .format("MMMM DD, YYYY")}
            .
          </li>
        )}
        {portfolioEntry && portfolioEntry.dateRange && (
          <li>
            The latest permitted ending date is{" "}
            {moment(portfolioEntry.dateRange.endDate)
              .endOf("month")
              .format("MMMM DD, YYYY")}
            .
          </li>
        )}
        <li>
          A minimum of 10 months, including the start and end months, are
          required for analysis.
        </li>
      </ul>
    </div>
  );
};

export { Render, isComplete, Description, getErrors };



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/PortfolioDates.js